import { enAccessControlPageTranslation } from './access-control';
import { enHomeTranslation } from './home';
import { enMeritocracyPageTranslation } from './meritocracy';
import { enMeritocracyParamatersPageTranslation } from './meritocracy-parameters';
import { enYourDataPageTranslation } from './your-data';

export const enPagesTranslation = {
  ...enMeritocracyPageTranslation,
  ...enAccessControlPageTranslation,
  ...enMeritocracyParamatersPageTranslation,
  ...enHomeTranslation,
  ...enYourDataPageTranslation,
};
